import axios from 'axios';
import { API_BASE_URL, createAuthHeader } from '../config/api.config';

export const fetchAvailableTags = async (clientId, token) => {
  if (!clientId || !token) {
    return [];
  }

  const response = await axios.get(
    `${API_BASE_URL}/experiments/tags?clientId=${clientId}`,
    {
      headers: createAuthHeader(token),
      timeout: 10000,
    }
  );

  return response.data?.tags || [];
};
